import { SendAssessmentDocumentArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../backend/functions/functions'

export const sendAssessmentDocument = httpsCallable<SendAssessmentDocumentArgs>(
  functions,
  'sendAssessmentDocument',
)
export const reportDocumentViewed = httpsCallable(functions, 'reportDocumentViewed')
